var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.64453 2.14746H1.76953V5.02246H4.64453V2.14746Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.64453 7.89746H1.76953V10.7725H4.64453V7.89746Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1.76953 13.6475H4.64453V16.5225H1.76953V13.6475Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.64453 19.3975H1.76953V22.2725H4.64453V19.3975Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M21.8945 2.14746H7.51953V5.02246H21.8945V2.14746Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M21.8945 7.89746H7.51953V10.7725H21.8945V7.89746Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M7.51953 13.6475H21.8945V16.5225H7.51953V13.6475Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M21.8945 19.3975H7.51953V22.2725H21.8945V19.3975Z",
    fill: "#000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListicon);
export default __webpack_public_path__ + "static/media/listicon.139b1246a74124d471afe18039228808.svg";
export { ForwardRef as ReactComponent };